import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, LogIn } from "lucide-react";
import SEO from "../components/SEO";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user === null) return null;
  if (user && user.role === "admin") return <Navigate to={location.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(email, password);
    setBusy(false);
  };

  return (
    <>
      <SEO title="Admin · Sign In" description="Ruken Alazdehar CMS admin login." path="/admin/login" noindex />
      <section className="min-h-screen flex items-center justify-center px-6 py-24" style={{ background: "linear-gradient(135deg, var(--brand-50), #fff)" }}>
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="Ruken" className="mx-auto h-14 w-auto object-contain bg-white/95 rounded-md p-2 shadow-sm" />
            <h1 className="mt-6 font-display text-3xl font-bold" style={{ color: "var(--brand-700)" }}>Admin Sign In</h1>
            <p className="mt-2 text-sm text-muted-foreground">Sign in to manage inquiries, news, and events.</p>
          </div>
          <form onSubmit={submit} className="bg-white rounded-2xl shadow-lg p-8 border border-border space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" data-testid="admin-email" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="admin-password" />
            </div>
            {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full text-white h-11" style={{ backgroundColor: "var(--brand-700)" }} data-testid="admin-login-submit">
              {busy ? <Loader2 size={16} className="animate-spin mr-2" /> : <LogIn size={16} className="mr-2" />}
              Sign In
            </Button>
          </form>
        </div>
      </section>
    </>
  );
}
